module.exports = __webpack_public_path__ + "media/flags/vn-bc191547.svg";